import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const classicBoardSettingsEntryPoint: EntryPoint<
	EntryPointComponent<
		Record<string, OperationType>,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
		Record<string, EntryPoint<any, any> | undefined>,
		{},
		{} | null
	>,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		import(
			/* webpackChunkName: "async-classic-board-settings-entrypoint" */ './src/BoardSettingsSwitcher.tsx'
		).then(({ BoardSettingsSwitcher }) => BoardSettingsSwitcher),
	),
	getPreloadProps: () => {
		return {};
	},
});
